import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

export const section = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.m};
`;

const SEPARATOR_WIDTH = `calc(${spacing.xs} * 2 + 4px)`;

export const heading = css`
  ${applyFont(typography.heading)}
  color: ${colors.neutral.heavy.default};
  margin: 0;
  overflow: hidden;
`;

export const headingRow = css`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-left: calc(-1 * ${SEPARATOR_WIDTH});
  row-gap: ${spacing.xs};
`;

export const headingName = css`
  padding-left: ${SEPARATOR_WIDTH};
`;

export const ratingItem = css`
  align-items: center;
  display: flex;
`;

export const dotSeparator = css`
  flex: 0 0 auto;
  text-align: center;
  width: ${SEPARATOR_WIDTH};
`;

export const mutedBodyText = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};
`;

export const ratingAndCount = css`
  ${applyFont(typography.body)}
  align-items: center;
  color: ${colors.neutral.medium.default};
  display: flex;
  gap: ${spacing.xxs};
`;

export const headingStar = css`
  color: ${colors.accentFour.trim.hover};
  flex: 0 0 auto;
  height: 20px;
  width: 20px;
`;

export const pipeSeparator = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.trim.default};
`;

export const list = css`
  display: flex;
  flex-direction: column;
`;
